module.exports = __webpack_public_path__ + "static/media/friends_purple.3c38e7ad.png";